import React from "react"
import { ITypeSelectorType, Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyTitle, TypeSelectorComponent } from "./common"
import { IUIPropertyDefinition } from "../common"
import jp from 'jsonpath'
import { Checkbox, Input } from "uxp/components"

export interface ITypeSelectorProperty {
    types: ITypeSelectorType[],
    type: string,
    itemWidth: string,
    numberOfButtons?: number,
    allignToCenter?: boolean
}

export function TypeSelectorProperty(defaultProps: ITypeSelectorProperty, title?: string, web?: boolean): IUIPropertyDefinition<ITypeSelectorProperty> {
    return {
        defaults: defaultProps,
        render: (props, uxpContext, data, containerId) => {

            let _props = props?.uiProps
            if (!_props?.numberOfButtons) {
                _props.numberOfButtons = 2
            }

            return <PropertyContainer>
                <PropertyContainerTitle>{title || 'Type'}</PropertyContainerTitle>
                <PropertyGroup>
                    <Property>
                        <PropertyTitle>Type</PropertyTitle>
                        <TypeSelectorComponent
                            types={defaultProps.types}
                            selected={_props.type || ''}
                            onChange={(s) => {
                                jp.apply(_props, '$.type', () => (s))
                                props.onChange(Object.assign({}, _props));
                            }}
                            itemWidth={defaultProps.itemWidth}
                        />
                    </Property>
                    {!!web ?
                        <Property>
                            <PropertyTitle>Number of buttons per row</PropertyTitle>
                            <Input
                                type='number'
                                value={_props?.numberOfButtons?.toString() || '2'}
                                onChange={(v) => {
                                    let num = Number(v)
                                    if (!num || isNaN(num) || !isFinite(num)) num = 2
                                    if (num > 6) num = 6
                                    jp.apply(_props, '$.numberOfButtons', () => (num))
                                    props.onChange(Object.assign({}, _props));
                                }}
                                className="widget-designer-input"
                            />
                        </Property>
                        : null
                    }

                    {
                        !!web ?
                            <Property>
                                <PropertyTitle>Align buttons to center</PropertyTitle>
                                <Checkbox
                                    checked={_props.allignToCenter || false}
                                    onChange={v => {
                                        _props.allignToCenter = v
                                        props.onChange(Object.assign({}, _props))
                                    }}
                                    label="Align to center"
                                />
                            </Property>
                            : null
                    }

                </PropertyGroup>
            </PropertyContainer>
        }
    }

}